import { render, staticRenderFns } from "./ViessmannInstallationTable.global.vue?vue&type=template&id=56b977dc&scoped=true&lang=pug&"
import script from "./ViessmannInstallationTable.global.vue?vue&type=script&lang=ts&"
export * from "./ViessmannInstallationTable.global.vue?vue&type=script&lang=ts&"
import style0 from "./ViessmannInstallationTable.global.vue?vue&type=style&index=0&id=56b977dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b977dc",
  null
  
)

export default component.exports